const constants = require('@/util/constants')
require('./config')

/**
 * 获取全部群组
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getGroups (successcb, failedcb) {
  axios.get('/api/group/get', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取群组详情
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getGroupDetail (gid, successcb, failedcb) {
  axios.get('/api/group/detail', {
    params: {
      'gid': gid,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取群组全部成员
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getGroupMembers (gid, successcb, failedcb) {
  axios.get('/api/group/members', {
    params: {
      'gid': gid,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建群组
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createGroup (nickname, type, selectedContacts, successcb, failedcb) {
  axios.post('/api/group/create', {
    nickname,
    type,
    selectedContacts,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新群组: 群名称等
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateGroupNickname (gid, nickname, successcb, failedcb) {
  axios.post('/api/group/update/nickname', {
    gid,
    nickname,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新群组公告
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateGroupAnnouncement (gid, announcement, successcb, failedcb) {
  axios.post('/api/group/update/announcement', {
    gid,
    announcement,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新群组简介
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateGroupDescription (gid, description, successcb, failedcb) {
  axios.post('/api/group/update/description', {
    gid,
    description,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 邀请/直接拉入群
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function inviteGroup (uid, gid, successcb, failedcb) {
  axios.post('/api/group/invite', {
    uid,
    gid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 主动申请入群
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function applyGroup (gid, successcb, failedcb) {
  axios.post('/api/group/apply', {
    gid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 主动申请入群：同意
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function applyGroupApprove (nid, successcb, failedcb) {
  axios.post('/api/group/apply/approve', {
    nid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 主动申请入群:拒绝
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function applyGroupDeny (nid, successcb, failedcb) {
  axios.post('/api/group/apply/deny', {
    nid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 踢人
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function kickGroupMember (gid, uid, successcb, failedcb) {
  axios.post('/api/group/kick', {
    gid,
    uid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 禁言
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function muteGroupMember (gid, uid, successcb, failedcb) {
  axios.post('/api/group/mute', {
    gid,
    uid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 移交群组
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function transferGroup (uid, gid, successcb, failedcb) {
  axios.post('/api/group/transfer', {
    uid,
    gid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 移交群组：同意
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function transferGroupApprove (nid, successcb, failedcb) {
  axios.post('/api/group/transfer/approve', {
    nid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 移交群组: 拒绝
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function transferGroupDeny (nid, successcb, failedcb) {
  axios.post('/api/group/transfer/deny', {
    nid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 退出群组
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function withdrawGroup (gid, successcb, failedcb) {
  axios.post('/api/group/withdraw', {
    gid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 解散群组
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function dismissGroup (gid, successcb, failedcb) {
  axios.post('/api/group/dismiss', {
    gid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 搜索过滤群组
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function filterGroup (keyword, successcb, failedcb) {
  axios.get('/api/group/filter', {
    params: {
      'keyword': keyword,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
